<template>
    <div>
        <ul class="day_info_list">
            <li v-for="(item, index) in checkBudget.planDayList" :id="'planDayBudget' + item.planDay" :key="index">
                <div class="time_box">
                    <span class="day_icon">D{{ item.planDay }}</span>
                    <div class="time">{{ dateFormatYMD(item.planDate, '-') }}</div>
                    <div style="margin-right:0.1rem">{{ getWeekDate(item.planDate) }}</div>
                    <div class="place">
            <span v-for="(city, ii) in item.cityList" :key="ii">{{ city.cityName }}<span
                v-if="ii != item.cityList.length - 1">-</span></span>
                    </div>
                </div>
                <div class="container">
                    <div v-for="(budget, ii) in item.budgetDetails" :id="'budget' + budget.id" :key="ii">
                        <div v-show="budget.isShow&&(chooseStockTypes.indexOf(budget.state) != -1 || (budget.state == 11 && chooseStockTypes.length == allStockTypes.length))" :style="budget.orderSize>0?'margin-top: 0.25rem;':''"
                             class="body_info">
                            <div v-if="budget.state == 11">
                                <div style="padding-top: 0.05rem">
                                    <div class="editimg" @click="openChangeTime">
                                        <i class="el-icon-edit-outline"
                                           style="color: white;font-size: 0.15rem;left: 0.04rem;"></i>
                                    </div>
                                    <span style="margin-left: 0.26rem;">{{ budget.resourceNameCn }}</span>
                                    <span v-if="budget.stayDate != item.planDate" class="time">
                    &nbsp;{{ dateFormatHM(budget.stayDate) }}-{{ dateFormatHM(budget.endStayDate) }}
                  </span>
                                    <span style="margin-left: 0.1rem">{{ budget.remark }}</span>
                                </div>
                            </div>
                            <div v-else style="    display: flex;">
                                <div class="info_left">
                                    <div class="price_img_box">
                                        <div :style="budget.status === 1 ? 'background:#888483' : ''" class="top_price"
                                             @click="openDetailDialog(budget)">
                                            <span v-if="budget.status === 1" style="color:white;"
                                                  @click.stop="openProductMoveDialog">已失效</span>
                                            <span v-else-if="budget.productType == 7">外观</span>
                                            <span v-else-if="budget.productType == 8">免费</span>
                                            <div v-else>
                        <span style="z-index: 1;">
                          {{
                                showCostPrice ? Number(budget.totalPrice.toFixed(2)) :
                                    Number(budget.saleTotalPrice.toFixed(2))
                            }}
                          <span class="currency">{{ budget.currency }}</span>
                        </span>
                                                <div v-if="!linkProductFlag" class="editimg">
                                                    <i class="el-icon-edit-outline"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-show="planProductShowStatus" class="bottom_img">
                                            <img :src="budget.imageUrl" alt="" width="100%">
                                            <div v-if="budget.status === 1" class="image-iop"
                                                 style="text-align: center;">点击调整
                                            </div>
                                        </div>
                                    </div>
                                    <div class="info_container">
                                        <div class="resource_name">
                                            <span>{{
                                                    budget.resourceNameCn != '' ? budget.resourceNameCn : budget.resourceNameEn
                                                }}&nbsp;</span>
                                            <span v-if="budget.star">
                        <i v-for="item1 in budget.star" :key="item1" class="el-icon-star-on"></i>
                      </span>
                                            <span v-if="(budget.stayDate != item.planDate || budget.endStayDate != item.planDate) && budget.state != 15"
                                                  class="time">
                        &nbsp;<span v-if="budget.stayDate != item.planDate && budget.endStayDate != item.planDate">{{
                                                    dateFormatHM(budget.stayDate)
                                                }}-{{ dateFormatHM(budget.endStayDate) }}</span>
                        <span v-else-if="budget.stayDate != item.planDate && budget.endStayDate == item.planDate">{{
                                dateFormatHM(budget.stayDate)
                            }}出发</span>
                        <span v-else>{{ dateFormatHM(budget.endStayDate) }}结束</span>
                      </span>
                                            <div v-if="budget.linkBudgetIds && budget.linkBudgetIds.length > 0">
                                                <el-link type="primary" @click="selectLinkProduct(budget)">
                                                    查看关联产品
                                                </el-link>
                                            </div>
                                        </div>
                                        <div v-show="planProductShowStatus">
                                            <div v-if="budget.inquiryId != ''" class="icon_box1" @click="getInquiryDetail(budget)">
                                                <div style="display: flex;align-items: center;margin-right: 0.1rem;"
                                                  v-if="budget.details&&budget.details.length>0">
                                                    <div v-if=" budget.details[0].isInquirySend==1"><a style="color: red;">已发送给客户</a></div>
                                                    <div v-else><a style="color: red;">暂未发送给客户</a></div>
                                                </div>
                                                <div class="icon-xun">
                                                    询单号 {{ budget.inquiryId }}
                                                </div>
                                                <div class="icon-right">
                                                    <div>专属</div>
                                                </div>

                                                <div v-if="budget.optionTime" class="icon-xun">
                                                    {{
                                                        getTimeNumber(budget.optionTime) != '已失效' ? getTimeNumber(budget.optionTime) + '后报价失效' :
                                                            getTimeNumber(budget.optionTime)
                                                    }}
                                                </div>
                                                <div v-if="budget.optionTime" class="icon-right">
                                                    <div>限时购</div>
                                                </div>
                                            </div>
                                            <div v-if="budget.state == 15" class="position_box">
                                                <div style="color: #02a0c6;font-size: 0.13rem;">
                                                    {{
                                                        budget.resourceDetail.startPortName
                                                    }}-{{ budget.resourceDetail.endPortName }}
                                                </div>
                                            </div>
                                            <div v-if="budget.state == 15" class="position_box">
                                                <div style="font-size: 0.13rem;color: black;">
                                                    参考{{ budget.resourceDetail.flightNumber }}
                                                    {{ budget.resourceDetail.startDate }}
                                                    {{
                                                        budget.resourceDetail.startTime
                                                    }}-{{ budget.resourceDetail.endTime }}{{
                                                        budget.resourceDetail.endTimeStr
                                                    }}
                                                </div>
                                            </div>
                                            <div v-if="budget.labels && budget.labels.length > 0" class="icon_box">
                                                <div v-for="(label, labelIndex) in budget.labels" :key="labelIndex"
                                                     class="icon">{{ label }}
                                                </div>
                                            </div>
                                            <div v-if="budget.addressCn && budget.addressCn != ''" class="position_box">
                                                <i class="el-icon-location"></i>
                                                {{ budget.addressCn }}
                                            </div>
                                            <div v-if="budget.introduce && budget.introduce != ''" style="display:flex">
                                                <span class="position_box">{{ budget.introduce }}</span>
                                                <el-tooltip placement="top" popper-class="addressBoxTip">
                                                    <div slot="content">{{ budget.introduce }}</div>
                                                    <span>更多</span>
                                                </el-tooltip>
                                            </div>
                                            <div class="info_price_box">
                        <span>
                          <p v-for="(detail, dindex) in budget.details" :key="dindex" style="margin-left: 0.08rem;">
                            <span v-show="detail.isShow">
                              <span v-if="detail.stockDetail.budgetType&&detail.stockDetail.budgetType!=''"
                                    class="desc">{{
                                      detail.stockDetail.budgetType
                                  }}&nbsp;&nbsp;</span>
                              <span v-if="detail.stockDetail.priceList && detail.stockDetail.priceList.length > 0&&detail.stockDetail.priceList[0].timeDesc
                                &&detail.stockDetail.priceList[0].timeDesc!=''"
                                    class="desc">{{
                                      detail.stockDetail.priceList[0].timeDesc
                                  }}&nbsp;&nbsp;</span>
                              <span>{{ detail.productName }}&nbsp;&nbsp;</span>
                              <span v-if="detail.stockDetail.productDesc" class="desc">
                                <el-tooltip placement="top">
                                  <div slot="content">{{ detail.stockDetail.productDesc }}</div>
                                  <span>{{
                                          detail.stockDetail.productDesc.length > 20 ? detail.stockDetail.productDesc.slice(0,
                                              20) + '...' : detail.stockDetail.productDesc
                                      }}</span>
                                </el-tooltip>
                              </span>
                              <span v-if="detail.stockDetail.stockDesc" class="desc">
                                <el-tooltip placement="top">
                                  <div slot="content">{{ detail.stockDetail.stockDesc }}</div>
                                  <span>{{
                                          detail.stockDetail.stockDesc.length > 20 ? detail.stockDetail.stockDesc.slice(0,
                                              20) + '...' : detail.stockDetail.stockDesc
                                      }}</span>
                                </el-tooltip>
                              </span>
                              <span v-if="detail.stockDetail && detail.stockDetail.cancelType" class="desc">
                                {{
                                      detail.stockDetail.cancelType == 1 ? "不可取消" : detail.stockDetail.cancelType == 5 ? "随时退"
                                          : detail.stockDetail.cancelType == 6 ? "过期退" : "有条件退"
                                  }}&nbsp;&nbsp;
                              </span>
                              <span>
                                {{ showCostPrice ? detail.stockPrice : detail.ratio }}{{ detail.currency }}
                                <span v-if="detail.stockDetail.priceList && detail.stockDetail.priceList.length > 0">
                                  {{ detail.stockDetail.priceList[0].priceCompany }}/{{
                                        detail.stockDetail.priceList[0].useTime
                                    }}
                                </span>
                                <span style="color:#8E2B0B;">{{ detail.stockNumber }}</span>
                                <span v-if="detail.stockDetail.priceList && detail.stockDetail.priceList.length > 0">
                                  {{ detail.stockDetail.priceList[0].priceCompany }}
                                </span>
                                <span v-if="detail.stockDetail.recommendation" class="desc">{{
                                        detail.stockDetail.recommendation
                                    }}</span>
                              </span>
                              <span v-show="(budget.details.length-1)==dindex">
                                <i v-if="budget.details.length != 0 && !linkProductFlag"
                                   class="el-icon-edit-outline"
                                   style="font-size:0.21rem;color:#BFBFBF" @click="openDetailDialog(budget,1)"></i>
                                <img v-if="budget.details.length != 0 && !linkProductFlag" src="../../../../assets/svg/add-grey.svg"
                                     style="width:0.21rem;vertical-align: top;"
                                     @click="addStockMore(budget)">
                              </span>
                            </span>
                          </p>
                        </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="planProductShowStatus" :style="budget.oldPlanId&&budget.oldPlanId!=''?'top: -15px;':''"
                                     class="info_right">
                                    <div v-if="budget.oldPlanId&&budget.oldPlanId!=''" class="info_right_top">
                    <span style="padding:0px 10px 0px 10px">
                      来自于 
                      <img :src="budget.oldPlanInfo.userImageUrl" style="width:19px;height:19px;margin-top:4px;"/>
                      {{ budget.oldPlanInfo.userName }}&nbsp;&nbsp;编号{{ budget.oldPlanId }}的方案
                    </span>
                                    </div>
<!--                                    v-show="budget.showOprationButton"-->
                                    <div  class="info_right_botton">
                                        <div v-if="!linkProductFlag" class="right_button4">
                                            <div class="right_button5" @click="openChangeTime">
                                                <svg-icon :iconClass="'clock'" :systemColor="'#2290AA'"></svg-icon>
                                            </div>
                                            <div @click="shareWithCustomers(budget)" class="right_button5">
                                                <svg-icon :iconClass="'share'" :systemColor="'#2290AA'"></svg-icon>
                                            </div>
                                        </div>
                                        <div class="right_button4">
                                            <div :style="budget.productType != 7 && budget.productType != 8 ? '' : 'background: #e4e4e4;color: #888483;'" class="right_button5"
                                                 @click="handlerBookClick(budget)">
                                                <span style="font-weight:800;">订</span>
                                            </div>
                                            <div class="right_button5" @click="deleteBudget(budget)">
                                                <svg-icon :iconClass="'if-ui-delete2-white'"
                                                          :systemColor="'#02A0C6'"></svg-icon>
                                            </div>
                                        </div>
                                        <div v-if="!linkProductFlag" class="right_button4">
                                            <div class="right_button5" @click="handlerInquiry(budget)">
                                                <span style="font-weight:800;">询</span>
                                            </div>
                                            <div class="right_button5" style="margin-right:0" @click="openTweetImage">
                                                <svg-icon :iconClass="'riFill-heart-fill-white'"
                                                          :systemColor="'#71CADF'"></svg-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="budget.orderSize>0" class="rightOrderDiv" @click="openDetailDialog(budget,1)">
                                <el-popover placement="bottom" trigger="hover" width="220">
                                    <div v-if="budget.orderStatusArr && budget.orderStatusArr.length > 0"
                                         slot="reference">
                    <span v-if="budget.orderStatusArr[0].orderNumber>0" class="info_right_orderNumber">
                      <span>订单号{{ budget.orderStatusArr[0].orderNumber.slice(0, 10) }}...</span>
                    </span>&nbsp;&nbsp;
                                        <span class="profit">
                      {{ budget.orderStatusArr[0].status }}&nbsp;&nbsp;
                    </span>
                                    </div>
                                    <div class="clsStatus">
                                        <div v-if="budget.orderStatusArr && budget.orderStatusArr.length > 0">
                                            <p v-for="(value, index1) in budget.orderStatusArr" :key="index1"
                                               class="three">
                                                <span class="three1">{{ value.orderNumber }}</span>&emsp;
                                                <span style="color: #DB4E1A;">{{ value.status }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <change-plan-time-dialog ref="changePlanTime" :checkBudgetDetail="checkBudget"></change-plan-time-dialog>
        <product-move ref="productMove"></product-move>
        <budget-single-detail-dialog ref="budgetSingleDetailDialog"
                                     :checkBudget="checkBudget"></budget-single-detail-dialog>
        <el-dialog :visible.sync="orderDetailVisible" append-to-body class="orderDetailDialog" destroy-on-close
                   width="80%">
            <static-table @updateList="updateList"  :loading="loading" :tableData="tableData" :dataType="dataType"></static-table>
        </el-dialog>
        <createPreOrder ref="orderPre"></createPreOrder>
        <tweet-image-dialog ref="tweetImage"></tweet-image-dialog>
        <PlanInquiryDetail ref="planInquiryDetail"></PlanInquiryDetail>
        <el-dialog :modal='false' :show-close='false' :visible.sync="deleteInfoVisible" class="deleteDialog"
                   width="17%">
            <div class="popover">
                <p>注意：此操作将会永久删除该数据不可恢复，您确定要删除吗？</p>
                <div>
                    <el-radio v-model="deleteRadio" label="1">仅删除&nbsp;<span
                        style="font-weight: bolder;">当天</span>&nbsp;的资源
                    </el-radio>
                    <el-radio v-model="deleteRadio" label="2">删除&nbsp;<span
                        style="font-weight: bolder;">行程内</span>&nbsp;的所有该资源
                    </el-radio>
                </div>
                <span class="dialog-footer">
          <el-button @click="deleteInfoVisible = false">取 消</el-button>
          <el-button type="primary" @click="deleteInfoSure()">确 定</el-button>
        </span>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import changePlanTimeDialog from '../dialog/changePlanTimeDialog.vue'
import ProductMove from '../dialog/productMove.vue'
import OrderApi from '@/components/Api/order.js'
import {sortByCreateTime} from '@/assets/utils/unit'
import BudgetSingleDetailDialog from '../dialog/budgetSingleDetailDialog.vue'
import staticTable from '../../../mechanism/components/myDealChild/child/staticTable.vue'
import createPreOrder from '../dialog/createPreOrder.vue'
import TweetImageDialog from '../dialog/tweetImageDialog.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import {refresh} from '../../js/function'
import {getPlanInfo} from '../../js/function'
import {debounce} from "@/assets/utils/unit";
import PlanInquiryDetail from './planInquiryDetail.vue'

export default {
    components: {
        changePlanTimeDialog,
        ProductMove,
        BudgetSingleDetailDialog,
        staticTable,
        createPreOrder,
        TweetImageDialog,PlanInquiryDetail
    },
    props: {
        checkBudget: {
            type: Object,
            default: () => {
                return {}
            }
        },
        chooseStockTypes: {
            type: Array,
            default: () => {
                return []
            }
        },
        allStockTypes: {
            type: Array,
            default: () => {
                return []
            }
        },
        showCostPrice: {
            type: Boolean,
            default: true,
        },
        planProductShowStatus: {
            type: Boolean,
            default: true,
        },
        linkProductFlag: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tableData: [],
            loading: false,
            orderDetailVisible: false,
            deleteInfoVisible: false,
            deleteRadio: '1',
            checkBudgetDetail: null,
            budgetDatas: {},
            dataType:0,
        }
    },
    methods: {
        //分享客户
        shareWithCustomers(budget) {
            sessionStorage.setItem('sharingBudget', JSON.stringify(budget))
            const route = this.$router.resolve({
                name: 'productSharing',
            })
            window.open(route.href, '_blank')
        },
        getInquiryDetail(budget){
            var inquiryId = budget.inquiryId
            var isSend = budget.details[0].isInquirySend
            var isOrder = budget.orderSize>0
            this.$refs.planInquiryDetail.beforeOpen(inquiryId,isSend,isOrder);
        },
        selectLinkProduct(item) {
            this.$emit("selectLinkProduct", item)
        },
        updateList() {
            this.getOrderList(this.budgetDatas)
        },
        deleteInfoSure() {
            var budgetDetailIds = []
            var budgetIds = []
            if (this.deleteRadio == '1') {
                budgetIds = this.checkBudgetDetail.budgetIds;
                this.checkBudgetDetail.details.forEach(element => {
                    budgetDetailIds = [...budgetDetailIds, ...element.budgetDetailIds]
                });
            } else {
                this.checkBudget.planDayList.forEach(e => {
                    e.budgetDetails.forEach(item => {
                        var flag;
                        if (item.resourceId == 0) {
                            flag = item.resourceNameCn == this.checkBudgetDetail.resourceNameCn
                        } else {
                            flag = item.resourceId == this.checkBudgetDetail.resourceId
                        }
                        if (flag) {
                            budgetIds = [...budgetIds, ...item.budgetIds];
                            item.details.forEach(element => {
                                budgetDetailIds = [...budgetDetailIds, ...element.budgetDetailIds]
                            });
                        }
                    })
                })
            }
            new PlanApi('plan').budgetDelete({
                budgetMainId: [this.checkBudget.id],
                budgetDetailIds: budgetDetailIds,
                budgetIds: budgetIds
            }).then(res => {
                if (res.status == 200) {
                    this.$message({type: "success", message: "删除成功"})
                    this.deleteInfoVisible = false
                    refresh(res.data, this.checkBudget.planId, this.checkBudgetDetail.budgetMainId)
                    this.$emit("deleteProduct")
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        deleteBudget(budget) {
            this.deleteInfoVisible = true;
            this.checkBudgetDetail = budget;
        },
        openTweetImage() {
            this.$refs.tweetImage.beforOpen(this.checkBudget);
        },
        handlerBookClick(val) {
            if (val.productType != 7 && val.productType != 8) {
                let budgetIds = []
                budgetIds.push(...val.budgetDetailIds)
                this.$refs.orderPre.init([...budgetIds, -1], 0)
            }
        },
        handlerInquiry(val) {
            var roomList = []
            if (val.state == 0) {
                val.details.forEach(e => {
                    roomList.push(e)
                })
            }
            var obj = {
                state: val.state,
                nameCn: val.resourceNameCn,
                nameId: val.resourceId,
                cityName: val.startLinkName,
                cityId: val.startLinkId,
                roomList: roomList,
                day: val.day
            }
            this.$Bus.$emit('openInquiryPage', obj)
        },
        openProductMoveDialog() {
            this.$refs.productMove.openDialog(this.checkBudget)
        },

        getOrderList(budget) {
            this.loading = true
            let childrenIds = []
            budget.details.forEach(eee => {
                childrenIds.push(eee.orderNumber)
            })
            var obj = {
                childrenIds: childrenIds,
            }
            if(budget.inquiryId){
                this.dataType = 1
                new OrderApi('order').platCustomerOrderList({"page": 1,"q": obj,"size": 100}).then(res => {
                    this.postOrderListSuccess(res)
                })
            }else{
                this.dataType = 0
                new OrderApi('order').platOrderList({"page": 1,"q": obj,"size": 100}).then(res => {
                    this.postOrderListSuccess(res)
                })
            }

        },
        postOrderListSuccess(res){
            this.loading = false
                if (res.status === 200) {
                    this.tableData = res.data.records
                    this.tableData.forEach((item) => {
                        if (item.truncationResult.opLogResults) {
                            item.truncationResult.opLogResults = sortByCreateTime(item.truncationResult.opLogResults)
                        }
                    })
                } else {
                    this.$message.error({message: res.statusText})
                }
        },
        openDetailDialog(budget, flag) {
            this.budgetDatas = budget
            if (!this.linkProductFlag) {
                if (flag && flag == 1) {
                    this.orderDetailVisible = true
                    this.getOrderList(budget)
                } else {
                    this.$refs.budgetSingleDetailDialog.openDialog(budget)
                }
            }
        },
        openChangeTime() {
            this.$refs.changePlanTime.openBefore()
        },
        addStockMore(budget) {
            //发送事件到行程轴右边做产品搜索
            this.$Bus.$emit('addStockMore', budget)
        },
    },
    watch:{
        checkBudget:{
            handler() {
                if(this.orderDetailVisible) {
                    this.getOrderList(this.budgetDatas)
                }
            },
            deep: true,
        }
    }
}
</script>

<style lang="scss" scoped>
.day_info_list {
    padding: 0 0.15rem;

    .info_right_top {
        position: relative;
        right: 0;
        height: 28px;
        background-color: white;
        box-shadow: 0px 1px 9px 2px rgba(0, 0, 0, 0.18);
        border-radius: 0.6rem .416667rem 0rem 0rem;
        line-height: 28px;
    }

    .info_right_botton {
        float: right;
    }

    .time_box {
        display: flex;
        align-items: center;
        position: sticky;
        z-index: 1;
        top: 0;
        background-color: white;

        .day_icon {
            width: 0.35rem;
            height: 0.35rem;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACUklEQVRYR+2Xy2vUUBTGv3NnyhSlUrSVJOMjxZV20UL/gSkW7KRV3Lh2Vt0LdW3Fre6tG3Wj0KXTTkpRO3sf4EaKVDqMTjKtKCoo83ByJKHJvEp7pwSmi7kQuLm533d+OfcmOSF0uVGX4+NAgC/TSqLP4TfK2vYfWdiNa0MDxyvRCRndvgDWjDoHxqLDPH/GLD6QBfhqKCkBeiyj2xegYCgLBLrD4LvxTHFBFqATXRvA1nV9MFoqjbvBhMBNAqUY/MRx8FQWYC/dMaq8P2X++N3q0QRgGdoSwDdkA3U6j8DpKju3zpk7n31tAGAZKgeGjOxuXwdBByMHeIdsa9cREr6YBc7Hl+28e+4BWEl1EYQ5d62JKK2t2O/c8U7WspFsL509reiOQMrdUwCtaBlrtg5gqDsAhol5VDWLH32zb1eG1Kroe8ZEj+IZ67ns7duzisE1ut2qcx/piKB1L7DDI+pqMUfBICOrmfakbJDDzrOS6joIiZrDk2dXi9kAgEEfQJg/rLG0jnGfwGNtANIGIU30X1L1JQD9BHiwwf9lSLF8m6ndjuO+Yir/nMv62vbro7MH0O1N2APoZaCXgV4GupaB78mTJ8oU+9X4jQ75GxDYWTPqBBhvvYEIXdTS1oZXEdmG8oJBV1srojBBmisifCr/jY2NZHMlDyCfPH0hSpHNIGC9JgyPoaEmFEJMKcuFV0FJ5mUhqVyCoCVmjIYXtdmJiC1muqdl7If+laayfCuh98cGKnqt6ihhQ8Si0cJwrT9P5ma50fvAf8OwQVr9ug7wH/8HmjAEHOudAAAAAElFTkSuQmCC) no-repeat;
            background-size: 0.35rem 0.35rem;
            font-weight: bold;
            color: #db4e1a;
            text-align: center;
            line-height: 0.45rem;
            font-size: 0.12rem;
        }

        .time {
            color: #333;
            margin: 0 0.15rem;
            font-size: 0.12rem;
        }

        .place {
            color: #333;
            font-weight: bold;
        }
    }

    .container {
        margin-left: 0.15rem;
        border-left: 1px dotted #e64a19;
        padding: 0.2rem 0 0.1rem 0.1rem;

        .body_info {
            position: relative;
            box-shadow: 0px 0.01rem 0.1rem 0px rgba(0, 0, 0, 0.18);
            display: flex;
            justify-content: space-between;
            padding-bottom: 0.07rem;
            margin-bottom: 0.1rem;

            .info_left {
                display: flex;

                .price_img_box {
                    width: 1rem;
                    margin-right: 0.08rem;

                    .top_price {
                        line-height: 0.35rem;
                        height: 0.35rem;
                        display: flex;
                        background: #db4e1a;
                        font-weight: bold;
                        color: white;
                        justify-content: center;
                        cursor: pointer;
                        font-size: 0.14rem;

                        .currency {
                            font-size: 0.12rem;
                        }
                    }

                    .top_price:hover {
                        background: #D81B43;
                    }

                    .bottom_img {
                        padding: 0.1rem;
                        background: #e4e4e4;
                        min-height: 0.6rem;
                    }
                }

                .info_container {
                    width: 4.52rem;

                    .resource_name {
                        font-weight: bold;
                        color: #db4e1a;
                        margin-top: 0.05rem;
                        font-size: 0.15rem;
                        display: flex;
                        align-items: center;

                        > div {
                            margin-left: 0.1rem;
                        }

                        .time {
                            font-size: 0.12rem;
                            color: black;
                        }
                    }

                    .icon_box1 {
                        display: flex;
                        margin-top: 0.05rem;
                        font-size: 0.12rem;

                        .icon-xun {
                            padding: 0.04rem 0.1rem;
                            border: 1px solid #02a0c6;
                            color: #02a0c6;
                            cursor: pointer;
                        }

                        .icon-right {
                            color: white;
                            background-color: #02a0c6;
                            margin-right: 0.1rem;
                            display: flex;
                            align-items: center;

                            > div {
                                transform: scale(0.8);
                                width: 0.36rem;
                                text-align: center;
                                font-weight: 600;
                            }
                        }
                    }

                    .icon_box {
                        margin-top: 0.05rem;
                        display: flex;
                        flex-wrap: wrap;

                        > div {
                            margin-bottom: 0.05rem;
                            padding: 0.04rem 0.05rem;
                            border: 1px solid #02a0c6;
                            color: #02a0c6;
                            margin-right: 0.1rem;
                            font-size: 0.12rem;
                        }
                    }

                    .position_box {
                        color: #686868;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-bottom: 0.05rem;
                        font-size: 0.12rem;
                        width: 92%;
                        display: block;

                        i {
                            color: #CECECE;
                        }
                    }

                    .info_price_box {
                        font-weight: bold;
                        color: #000000;
                        width: 100%;

                        .desc {
                            font-size: 0.12rem;
                            font-weight: normal;
                        }
                    }
                }
            }

            .info_right {
                position: absolute;
                right: 0.01rem;

                .right_button4 {
                    display: flex;

                    > div:last-child {
                        margin-left: 0.02rem;
                    }

                    .right_button5 {
                        width: 0.27rem;
                        height: 0.27rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #e5f5f9;
                        color: #02a0c6;
                        cursor: pointer;
                        margin-bottom: 0.02rem;

                        > svg {
                            width: 0.15rem;
                            height: 0.15rem;
                        }
                    }

                    .right_button5:hover {
                        background: #db4e1a;

                        > svg {
                            color: white !important;
                        }

                        > span {
                            color: white !important;
                        }
                    }
                }
            }

            .rightOrderDiv {
                font-size: 0.12rem;
                box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.18);
                border-radius: 10px 1px 0rem 0rem;
                background: white;
                padding: 0.08rem;
                position: absolute;
                top: -0.15rem;
                right: 0;
                cursor: pointer;

                .profit {
                    color: #DB4E1A;
                }
            }

            .editimg {
                border-radius: 50%;
                background-color: #db4e1a;
                width: 0.25rem;
                height: 0.25rem;
                position: absolute;
                top: -0.1rem;
                left: -0.08rem;

                i {
                    position: absolute;
                    top: 0.04rem;
                    left: 0.035rem;
                }
            }

            .editimg:hover {
                background: #D81B43;
            }
        }
    }
}

.deleteDialog {
    /deep/ .el-dialog {
        margin-top: 45vh !important;
        margin-left: 6.5rem !important;
        border: 2px solid #02a0c6 !important;
    }

    /deep/ .el-dialog__header {
        padding: 0.1rem;
    }

    /deep/ .el-radio__inner {
        width: 0.18rem;
        height: 0.18rem;
        border: 3px solid #02a0c6;
        background-color: transparent;
    }

    /deep/ .el-radio__inner::after {
        width: 0.08rem;
        height: 0.08rem;
        background: #02a0c6;
    }

    /deep/ .el-radio__label {
        color: #101010;
    }

    .popover {
        > p {
            margin-bottom: 0.2rem;
            line-height: 0.22rem;
        }

        > div {
            > label {
                margin-bottom: 0.1rem;
            }
        }

        .dialog-footer {
            display: flex;
            justify-content: center;
            margin-top: 0.05rem;

            > button {
                padding: 0.08rem 0.2rem;
            }

            > button:last-child {
                background: #f5ad33;
                color: white;
                border: none;
            }

            > button:first-child:hover {
                color: #f39800;
                border-color: #fbe0b3;
                background-color: #fef5e6;
            }
        }
    }
}
</style>
